module.exports = __webpack_public_path__ + "img/2019_L.8a67b382.png";